import React from "react";
import Navbar from "../components/Navbar";


const NotFound = () => {
  return (
    <div>
      <Navbar />
      <div
        className="container d-flex flex-column align-items-center justify-content-center text-center"
        style={{ minHeight: "80vh" }}
      >
        <div>
          <h1
            style={{
              fontSize: "10em",
              fontWeight: "900",
              letterSpacing: "-0.05em",
              color: "#ff6503",
            }}
          >
            404
          </h1>
          <h2 className="fw-bold brand-blue" style={{ fontSize: "2em" }}>
            Oops! Page not found.
          </h2>
          <p className="text-muted" style={{ fontSize: "1.1em", marginTop: "1rem" }}>
            The page you're looking for doesn't exist or has been moved.
          </p>
          <div className="mt-4">
            <a href="/" className="btn btn-primary btn-lg me-3">
              Go to Homepage
            </a>
            <a
              href="/contact"
              className="btn btn-outline-primary btn-lg"
              style={{
                borderColor: "#0041a9",
                color: "#0041a9",
              }}
            >
              Contact Support
            </a>
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default NotFound;
